import { Component, Input } from '@angular/core';
import { getSignMethodMeta, SignMethodMeta } from '../../common/signing-method';

@Component({
  selector: 'app-method-badge',
  templateUrl: './method-badge.component.html',
  styleUrls: ['./method-badge.component.css'],
  standalone: false
})
export class MethodBadgeComponent {
  /** Recipient signing method code: qes | bio | initials. Null renders nothing. */
  @Input() method: string | null | undefined;

  get meta(): SignMethodMeta | null {
    return getSignMethodMeta(this.method);
  }

  get badgeStyle(): { [key: string]: string } {
    const meta = this.meta;
    return meta ? { color: meta.accent, background: meta.accentTint } : {};
  }
}
